@if (componentData$ | async; as data) {
<cx-generic-link [url]="data.urlLink" [target]="data.external == 'true' ? '_blank' : null">
  @if (data.headline || data.content) {
  <div class="carousel-caption">
    @if (data.headline) {
    <p class="main-heading" [innerHTML]="data.headline"></p>
    } @if (data.content) {
    <p class="sub-heading" [innerHTML]="getContent(data)"></p>
    } @if (data.content) {
    <button class="btn btn-success">{{ getButtonText(data) }}</button>
    }
  </div>
  }
  <cx-media [container]="data.media"></cx-media>
  @if (data?.media?.desktop?.altText) {
  <h3 class="text-center category-text">
    {{ data?.media?.desktop?.altText }}
  </h3>
  }
</cx-generic-link>
}
